// @ts-nocheck

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import RoundedButton from '../../../components/RoundedButton';
import SoundPlayer from '../../../singletons/SoundPlayer';
import theme from '../../../styled-components/dark';
import { SoundIds } from '../../../types/sounds';
import { KLMainLogo } from '../assets/img';
import { KLGlobalStatuses } from '../types/global';
import { type KLGlobalStatus } from '../types/global';
import { KLViewTypes } from '../types/view';

import KLSoundButton from './common/KLSoundButton';
import KLViewWrapper from './common/KLViewWrapper';

const StyledKLViewWrapper = styled(KLViewWrapper)`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const LogoWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainLogo = styled.img`
  max-width: 60%;
  max-height: 100%;
  object-fit: cover;
  object-position: center;
`;

const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  font-family: 'BettingArchivoNarrow';

  padding-bottom: 2.5em;
`;

const ReviewAdventureBtn = styled(RoundedButton)`
  width: 50%;
  margin-right: 1em;
  text-align: center;
`;

const RestartAdventureBtn = styled(RoundedButton)`
  width: 50%;
`;

type KLEliminatedViewProps = {
  shouldPlaySound?: boolean;
  reviewAdventure: () => void;
  restartAdventure: () => void;
  globalStatus: KLGlobalStatus;
};

const KLEliminatedView = ({
  shouldPlaySound,
  reviewAdventure,
  restartAdventure,
  globalStatus,
}: KLEliminatedViewProps) => {
  const [sound, setSound] = useState(null);

  useEffect(() => {
    if (!sound) {
      SoundPlayer.load(SoundIds.KL_TRY_AGAIN).then((s) => {
        setSound(s);
      });
    }

    return () => {
      if (sound) {
        sound.stop();
        setSound(null);
      }
    };
  }, [sound]);

  useEffect(() => {
    if (sound) {
      if (shouldPlaySound) {
        sound.play();
      } else {
        sound.stop();
      }
    }
  }, [sound, shouldPlaySound]);

  return (
    <StyledKLViewWrapper viewType={KLViewTypes.ELIMINATED}>
      {sound && shouldPlaySound ? <KLSoundButton sound={sound} /> : null}
      <LogoWrapper>
        <MainLogo src={KLMainLogo} />
      </LogoWrapper>
      <Footer>
        <ReviewAdventureBtn
          backgroundColor={theme.KLNotificationViewer.skipAllBtn.backgroundColor}
          borderColor={theme.KLNotificationViewer.skipAllBtn.backgroundColor}
          color={theme.KLNotificationViewer.skipAllBtn.color}
          label="Revoir mon aventure"
          onClick={reviewAdventure}
        />
        <RestartAdventureBtn
          backgroundColor={theme.KLNotificationViewer.nextBtn.backgroundColor}
          borderColor={theme.KLNotificationViewer.nextBtn.backgroundColor}
          color={theme.KLNotificationViewer.nextBtn.color}
          label="Recommencer"
          onClick={restartAdventure}
          disabled={globalStatus === KLGlobalStatuses.ENDING}
        />
      </Footer>
    </StyledKLViewWrapper>
  );
};

export default KLEliminatedView;
